import React from 'react';
import { format } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiTrendingDown, FiMinus, FiExternalLink } = FiIcons;

const NewsTable = ({ newsData }) => {
  const getSentimentColor = (sentiment) => {
    switch (sentiment) {
      case 'positive': return 'text-green-600 bg-green-50';
      case 'negative': return 'text-red-600 bg-red-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const getSentimentIcon = (sentiment) => {
    switch (sentiment) {
      case 'positive': return FiTrendingUp;
      case 'negative': return FiTrendingDown;
      default: return FiMinus;
    }
  };

  const getImpactColor = (impact) => {
    if (impact > 0.05) return 'text-green-600';
    if (impact < -0.05) return 'text-red-600';
    return 'text-gray-600';
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Recent News & Impact</h3>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 font-semibold">Date</th>
              <th className="text-left py-3 px-2 font-semibold">Headline</th>
              <th className="text-center py-3 px-2 font-semibold">Sentiment</th>
              <th className="text-right py-3 px-2 font-semibold">Impact</th>
              <th className="text-left py-3 px-2 font-semibold">Source</th>
            </tr>
          </thead>
          <tbody>
            {newsData.slice(0, 20).map((news) => (
              <tr key={news.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-2 text-gray-600">
                  {format(new Date(news.date), 'MMM dd')}
                </td>
                <td className="py-3 px-2">
                  <div className="max-w-md">
                    <p className="font-medium text-gray-800 truncate">
                      {news.headline}
                    </p>
                    <p className="text-xs text-gray-500 capitalize">
                      {news.type}
                    </p>
                  </div>
                </td>
                <td className="py-3 px-2 text-center">
                  <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs ${getSentimentColor(news.sentiment)}`}>
                    <SafeIcon 
                      icon={getSentimentIcon(news.sentiment)} 
                      className="w-3 h-3 mr-1" 
                    />
                    {news.sentiment}
                  </div>
                </td>
                <td className="py-3 px-2 text-right">
                  <span className={`font-medium ${getImpactColor(news.impact)}`}>
                    {news.impact > 0 ? '+' : ''}{(news.impact * 100).toFixed(1)}%
                  </span>
                </td>
                <td className="py-3 px-2">
                  <div className="flex items-center">
                    <span className="text-gray-600">{news.source}</span>
                    <SafeIcon icon={FiExternalLink} className="w-3 h-3 ml-1 text-gray-400" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewsTable;